import identity from "lodash/fp/identity";

class HomePageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    return identity(data);
  }
}

export default HomePageTransform;



// WEBPACK FOOTER //
// ./src/pages/home/home.transforms.js